// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".articles[data-v-000f25e2]{display:grid;grid-template-columns:subgrid;gap:16px;grid-column:1/-1}.articles .header-image[data-v-000f25e2]{border-radius:8px;display:inline-block;aspect-ratio:2/1;height:72px;max-width:unset}", ""]);
// Exports
module.exports = exports;
